import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { useAuthStore } from '@store/useAuthStore';

type TokenErrorResponse = {
	message?: string;
};

// 동시에 여러 요청이 401을 만나도 안내가 한 번만 노출되도록 토스트 ID를 고정
const TOKEN_EXPIRED_TOAST_ID = 'token-expired';

// 토큰 갱신 실패(세션 만료) 처리 — 안내 토스트 노출 후 로그아웃
export const handleTokenExpired = (error: unknown): void => {
	const errorData = (error as AxiosError).response?.data as TokenErrorResponse | undefined;

	toast.error(errorData?.message || '토큰이 만료되어 로그아웃 되었습니다.', {
		toastId: TOKEN_EXPIRED_TOAST_ID
	});

	useAuthStore.getState().logout();
};
